import lipkiss from './Uact/act0.gif';
import cartoonrose from './Uact/act1.gif';
import coffi from './Uact/act2.gif';
import icebath from './Uact/act3.gif';
import ladyfinger from './Uact/act4.gif';
import sprlikrose from './Uact/act5.gif';
import seiwing from './Uact/act6.gif';
import dropballbox from './Uact/act7.gif';
import playupdwngm from './Uact/act8.gif';
import massage from './Uact/act9.gif';
import bedkiss from './Uact/act10.gif';
import dimond from './Homeitems/dimond.gif';
import bannahole from './Uact/act11.gif';
import strubery from './Uact/act12.gif';
import mango from './Uact/act13.gif';

import apple from './Uact/act14.png';
import opnbanana from './Uact/act15.png';
import capsicum from './Uact/act16.png';
import cheery from './Uact/act17.png';
import drgnfruit from './Uact/act18.jpg';
import greenapple from './Uact/act19.png';
import guava from './Uact/act20.png';
import orange from './Uact/act21.png';
import peach from './Uact/act22.png';
import pinapple from './Uact/act23.png';
import plumb from './Uact/act24.jpg';
import pumpkin from './Uact/act25.png';
import redapple from './Uact/act26.png';
import staberry from './Uact/act27.png';
import tomato from './Uact/act28.png';
import tornado from './Uact/act29.png';
import watermeelon from './Uact/act30.png';
import lemon from './Uact/act31.png';

export const actptnr=(itemid:any)=>{
let itemimg = massage;
if(itemid == 33) itemimg = lipkiss;
else if(itemid == 1) itemimg = cartoonrose;
else if(itemid == 2) itemimg = coffi;
else if(itemid == 3) itemimg = icebath;
else if(itemid == 4) itemimg = ladyfinger;
else if(itemid == 5) itemimg = sprlikrose;
else if(itemid == 6) itemimg = seiwing;
else if(itemid == 7) itemimg = dropballbox;
else if(itemid == 8) itemimg = playupdwngm;
else if(itemid == 9) itemimg = massage;
else if(itemid == 10) itemimg = bedkiss;
else if(itemid == 11) itemimg = dimond;
else if(itemid == 12) itemimg = bannahole;
else if(itemid == 13) itemimg = strubery;
else if(itemid == 14) itemimg = mango;
else if(itemid == 15) itemimg = apple;
else if(itemid == 16) itemimg = opnbanana;
else if(itemid == 17) itemimg = capsicum;
else if(itemid == 18) itemimg = cheery;
else if(itemid == 19) itemimg = drgnfruit;
else if(itemid == 20) itemimg = greenapple;
else if(itemid == 21) itemimg = guava;
else if(itemid == 22) itemimg = orange;
else if(itemid == 23) itemimg = peach;
else if(itemid == 24) itemimg = pinapple;
else if(itemid == 25) itemimg = plumb;
else if(itemid == 26) itemimg = pumpkin;
else if(itemid == 27) itemimg = redapple;
else if(itemid == 28) itemimg = staberry;
else if(itemid == 29) itemimg = tomato;
else if(itemid == 30) itemimg = tornado;
else if(itemid == 31) itemimg = watermeelon;
else if(itemid == 32) itemimg = lemon;

//alert(props.itemid);
return(
<div className="per100">
	<div>
	<img style={{width:'22vw',height:'32vh'}} src={itemimg} className="c-pfp-img" />

	</div>		
		
 </div>
);
}

